import React from 'react'
import classnames from 'classnames'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'

import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'

import priceUtils from 'utils/price'

const useStyles = makeStyles(theme => ({
  cell: {
    minHeight: '270px',
    height: '270px',
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  cardContent: {
    width: '100%',
    flexGrow: 1,
  },
  cardActions: {
    padding: theme.spacing(2),
    width: '100%',
    flexGrow: 0,
  },
  title: {
    
  },
  subtitle: {
    marginBottom: 12,
  },
  description: {
    color: theme.palette.grey[500],
  },
  featureContainer: {
    paddingTop: theme.spacing(2),
  },
  feature: {
    marginBottom: theme.spacing(0.5),
    '& p': {
      margin: 0,
      fontSize: '0.8em',
      display: 'list-item',
      listStyleType: 'disc',
      listStylePosition: 'inside',
    }
  },
}))

const Products = ({
  products,
  spacing = 1,
  cellSize = 12,
  getFeatures = (metadata) => [],
  getActions = (product) => null,
  getCardTheme = (product) => ({}),
}) => {
  const classes = useStyles()
  
  return (
    <Grid
      container
      spacing={ spacing }
      direction="row"
      alignItems="stretch"
    >
      {
        products.map((product) => {

          const productFeatures = getFeatures(product.metadata)
          const productActions = getActions(product)
          const cardTheme = getCardTheme(product)

          return (
            <Grid
              item
              key={ product.id }
              xs={ 12 }
              sm={ 12 }
              md={ cellSize }
              className={ classnames(classes.cell, cardTheme.cell) }
            >
              <Card raised className={ classnames(classes.card, cardTheme.card) }>
                <CardContent className={ classnames(classes.cardContent, cardTheme.cardContent) }>
                  <Typography className={ classnames(classes.title, cardTheme.title) } variant="h6" component="h2">
                    { product.name }
                  </Typography>
                  <Typography className={ classnames(classes.subtitle, cardTheme.subtitle) } color="textSecondary">
                    £{ priceUtils.displayPrice(product.price.unit_amount) } per month
                  </Typography>
                  <Typography className={ classnames(classes.description, cardTheme.description) } variant="body2" component="p">
                    { product.description }
                  </Typography>
                  <div className={ classes.featureContainer }>
                    {
                      productFeatures.map((feature, i) => {
                        return (
                          <div
                            key={ i }
                            className={ classes.feature }
                          >{ feature }</div>
                        )
                      })
                    }
                  </div>
                </CardContent>
                <CardActions className={ classnames(classes.cardActions, cardTheme.cardActions) }>
                  {
                    productActions
                  }
                </CardActions>
              </Card>
            </Grid>
          )
        })
      }
    </Grid>
  )
}

export default Products